import { Collection } from 'modules/core/lib/mobx-rest'
import AccessGroup from 'modules/core/store/models/AccessGroup'

/**
 * @deprecated Do not use the generic access group model, we're removing it from the API. Create a domain specific entity instead.
 */
class AccessGroups extends Collection<AccessGroup> {
  get cacheKey(): string {
    return 'accessGroups'
  }

  model() {
    return AccessGroup
  }

  async create(_attributes: unknown, _options: unknown): Promise<never> {
    throw new Error("Can't modify generic access groups through the API")
  }

  async delete(_model: unknown) {
    throw new Error("Can't modify generic access groups through the API")
  }
}

const singleton = new AccessGroups()
export default singleton
